import { ApiHelper } from 'utils/apiHelper';

import * as PermissionTypes from 'reactApp/modules/PermissionsModule/PermissionModule.types';

const RESPONSE_MOCK: Partial<PermissionTypes.AllPermissions> = {};

export const PermissionApi = {
    async loadData(pid: string) {
        const result = await ApiHelper.rpcCall<PermissionTypes.AllPermissions>({
            url: `/api/v1/projects/${pid}/policy`,
        });

        return {
            ...result,
            ...RESPONSE_MOCK,
        };
    },
};
